var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJj(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5046_70676)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.83444 21.9032L6.93127 17.701C6.23531 17.9412 5.58184 18.197 4.98682 18.4788L7.2766 21.9868C7.45192 21.9607 7.63787 21.9293 7.83444 21.9032Z",
    fill: "#F08300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0678 16.3178L9.19482 21.8093C9.3914 21.8093 9.58797 21.8093 9.78454 21.8198L15.8729 16.0568C14.9485 16.109 14.0082 16.1925 13.0678 16.3178Z",
    fill: "#F08300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4032 21.8458L9.26917 17.0225C8.67946 17.1686 8.10038 17.3252 7.54785 17.5027L7.99412 21.8876C8.12694 21.8719 8.26507 21.8563 8.4032 21.8458Z",
    fill: "#F08300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2532 16.537C22.0779 16.49 21.8919 16.4483 21.706 16.4065L10.9424 21.9711C11.224 22.0338 11.5002 22.1121 11.7659 22.2165L24.3039 17.4088C23.8523 17.0747 23.1723 16.7771 22.2532 16.537Z",
    fill: "#F08300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0581 22.3417C12.3662 22.4879 12.6531 22.6654 12.9188 22.8846L20.1706 22.1277C23.5495 20.9636 25.2974 19.4916 24.9627 18.2753L12.0581 22.3417Z",
    fill: "#F08300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 19.6951L6.35764 22.1799C6.55953 22.1329 6.79329 22.0807 7.06424 22.0285L4.36006 18.7972C3.80222 19.0948 3.35064 19.3976 3 19.6951Z",
    fill: "#F08300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0998 16.0254L10.002 21.8354C10.2304 21.8563 10.4642 21.8824 10.6926 21.9241L20.3405 16.1872C19.3364 16.0619 18.242 16.0097 17.0998 16.0254Z",
    fill: "#F08300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00846 21.8145L12.127 16.4535C11.4311 16.5631 10.7404 16.6936 10.0657 16.8398L8.57812 21.8354C8.71626 21.825 8.86501 21.8145 9.00846 21.8145Z",
    fill: "#F08300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6812 13.7912L13.275 15.3207L13.1687 12.5488L14.04 14.7622L14.8582 11.3326L14.8475 14.3968L16.707 10.3303L15.5913 14.2349L18.5239 9.60471L16.3882 14.0627L20.3993 9.30716L16.8132 14.402L21.9082 9.8866L17.2489 14.7465L21.8603 12.2409C22.1207 11.9433 22.3704 11.6406 22.6041 11.3273C25.8768 6.98422 24.6389 4.24366 20.5587 5.36599C17.3233 6.26384 13.6097 9.34371 11.8352 12.2043C11.0596 13.4519 10.693 14.5638 10.6983 15.4303L12.6268 15.9315L11.6812 13.7912Z",
    fill: "#00A161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33238 14.2976L7.74967 15.8376L5.40676 12.0112L7.8453 14.6578L5.79459 10.179L8.1375 13.8644L6.47462 8.8374L8.50408 13.2118L7.43622 8.7852L9.04066 13.1388L8.35001 9.08797L9.59319 13.3371L9.42849 9.7979L10.167 13.7391L10.4857 10.7062C10.3901 10.4661 10.2892 10.2364 10.1829 10.0067C9.04597 7.6159 7.44153 6.46226 6.25148 6.73892C5.03487 7.02081 4.03076 8.84784 4.03076 11.6615C4.03076 13.4676 4.4239 15.4356 5.173 17.1687L7.81342 17.1948L5.33238 14.2976Z",
    fill: "#005BAC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5046_70676"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 17.7692,
    fill: "white",
    transform: "translate(3 5.11548)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJj);
export default __webpack_public_path__ + "static/media/jj.70333a16612696166bc879c856212366.svg";
export { ForwardRef as ReactComponent };